import FooterExample from "../../../../../../packages/design-system/src/FooterLinks/readme-helpers";
import * as React from 'react';
export default {
  FooterExample,
  React
};